import { IssueStatus } from '@cims-online/shared'
import { useDisabledOptions } from 'hooks/useDisabledOptions'
import { Issue } from '../../../../../IssueTrackerContext/types'
import { HelpMessage } from 'utils/constants'
import CIMSFormItem from 'components/CIMSFormItem'
import CIMSSelect from 'components/CIMSSelect'
import { useIssueReportsSelectOptionsContext } from '../../../../../../../IssueReportsSelectOptionsContext'

const Reports: React.VFC<Pick<Issue, 'statusId'>> = ({ statusId }) => {
  const { selectProps } = useIssueReportsSelectOptionsContext()
  const [disabled, { some }] = useDisabledOptions([
    {
      disabled: statusId === IssueStatus.Closed.id,
      reason: { why: 'invalid status', statusName: IssueStatus.Closed.name },
    },
  ])
  return (
    <CIMSFormItem
      label="Reports"
      name="reports"
      help={HelpMessage.Issues.IssueTracker.Reports}
      disabled={disabled}
    >
      <CIMSSelect {...selectProps} disabled={some} />
    </CIMSFormItem>
  )
}

export default Reports
